import React from 'react';
/**
 * copied from formik
 * @param children
 */
export const isEmptyChildren = (children: unknown): boolean => React.Children.count(children) === 0;
